module.exports = __webpack_public_path__ + "assets/img/modal-avatar-a17fe931.png";